import { Component, Prop, Vue } from 'nuxt-property-decorator';

import IconClose from '../../assets/svg/x.svg';

@Component<Notification>({
  components: {
    IconClose
  }
})
export default class Notification extends Vue {
  @Prop()
  icon!: any;

  @Prop()
  title!: string;

  @Prop({ type: String, default: '#FF5B35' })
  color!: string;

  // Variants
  @Prop({ type: Boolean, default: true })
  border!: boolean;

  get hasIcon(): boolean {
    return !!this.icon;
  }

  action(e: Event): void {
    e.preventDefault();

    this.$emit('action', e);
  }

  close(e: Event): void {
    e.preventDefault();

    this.$emit('close', e);
  }
}
